export const docInitialState = {
    showUploader: false
};

export function docReducer(state, action) {
    switch (action.type) {
        case 'SHOW_UPLOADER':
            return { ...state, showUploader: true };

        case 'HIDE_UPLOADER':
            return { ...state, showUploader: false };

        // case 'HIDE_UPLOADER_WITH_CONDITION':
        //     // same logic you wrote in hideFileUploader()
        //     const shouldHide = (action.payload) || !action.payload;

        //     return { ...state, showUploader: !shouldHide };

        default:
            return state;
    }
}
